<template lang="pug">
  el-popover(
    placement='bottom'
    trigger='click'
    v-model="visible"
  )
    div.new-datepicker
      div.calendar-quickmenu
        el-button(type='text' v-on:click='today' :class='getActive("today")') Today
        el-button(type='text' v-on:click='yesterday' :class='getActive("Yesterday")') Yesterday
        el-button(type='text' v-on:click='thisMonth' :class='getActive("This month")') This month
        el-button(type='text' v-on:click='lastMonth' :class='getActive("Last Month")') Last Month
        el-button(type='text' v-on:click='thisYear' :class='getActive("This Year")') This Year
        el-button(type='text' v-on:click='lastYear' :class='getActive("Last Year")') Last Year
      div.overflow-auto
        div.table-row
          div.calendar-one
            div.select-div
              el-select(
                v-model='selectedMonth1'
                placeholder='Select'
                filterable
                v-on:change='monthChange1($event)'
              )
                el-option(
                  v-for='item in monthList'
                  :key='item.id'
                  :label='item.name'
                  :value='item.abbreviation')
              el-select(
                v-model='selectedYear1'
                placeholder='Select'
                filterable
                v-on:change='yearChange1($event)'
              )
                el-option(
                  v-for='item in yearList'
                  :key='item.id'
                  :label='item.year'
                  :value='item.year')
            date-table(
                :month='selectedMonth1'
                :year='selectedYear1'
                :date='selectedDate1'
                :startDate='Number(selectedDay1)'
                :endDate='Number(selectedDay2)'
                :calId=1
                :specialCase='specialCase'
                @emitSelectedDate='handleSelectedDate1("date", $event)'
                @resetSpecailCase='resetSpecailCase($event)'
                @mouseover.native='mouseover1'
              )
          div.calendar-two
            div.select-div
              el-select(
                v-model='selectedMonth2'
                placeholder='Select'
                filterable
                v-on:change='monthChange2($event)'
              )
                el-option(
                  v-for='item in monthList'
                  :key='item.id'
                  :label='item.name'
                  :value='item.abbreviation')
              el-select(
                v-model='selectedYear2'
                placeholder='Select'
                filterable
                v-on:change='yearChange2($event)'
              )
                el-option(
                  v-for='item in yearList'
                  :key='item.id'
                  :label='item.year'
                  :value='item.year')
            date-table(
                :month='selectedMonth2'
                :year='selectedYear2'
                :date='selectedDate2'
                :startDate='Number(selectedDay1)'
                :endDate='Number(selectedDay2)'
                :calId=2
                :specialCase='specialCase'
                @emitSelectedDate='handleSelectedDate2("date", $event)'
                @resetSpecailCase='resetSpecailCase($event)'
                @mouseover.native='mouseover2'
              )
    div.calendar-footer
      el-col
        el-button(@click='closePopover') Cancel
        el-button(@click='reset') Reset
        el-button(type='primary' @click='onSelectDate') Apply

    el-input(
      placeholder='Pick a date'
      v-model='input1'
      slot='reference'
      v-on:change='refresh'
    ).dateInput
      template(slot='append')
        el-button(type='submit' icon='el-icon-date' click="btnDelteClicked")
</template>
<script>
import moment from 'moment';
import DateTable from './DateTable';

export default {
  name: 'MyCustomeCalendarControl',
  components: { DateTable },
  data() {
    return {
      visible: false,
      activeCalender: 0,
      selectedQuickLink: null,
      monthList: [
        {
          id: 1,
          abbreviation: 'Jan',
          name: 'January',
        },
        {
          id: 2,
          abbreviation: 'Feb',
          name: 'February',
        },
        {
          id: 3,
          abbreviation: 'Mar',
          name: 'March',
        },
        {
          id: 4,
          abbreviation: 'Apr',
          name: 'April',
        },
        {
          id: 5,
          abbreviation: 'May',
          name: 'May',
        },
        {
          id: 6,
          abbreviation: 'Jun',
          name: 'June',
        },
        {
          id: 7,
          abbreviation: 'Jul',
          name: 'July',
        },
        {
          id: 8,
          abbreviation: 'Aug',
          name: 'August',
        },
        {
          id: 9,
          abbreviation: 'Sep',
          name: 'September',
        },
        {
          id: 10,
          abbreviation: 'Oct',
          name: 'October',
        },
        {
          id: 11,
          abbreviation: 'Nov',
          name: 'November',
        },
        {
          id: 12,
          abbreviation: 'Dec',
          name: 'December',
        },
      ],
      saperator: 'To',
      specialCase: {
        m1: 1,
        m2: 2,
        y1: 3,
        y2: 4,
      },
      yearList: [],
      dateFormat: 'MM/DD/YYYY',
      selectedDay1: null,
      selectedDate1: null,
      selectedMonth1: null,
      selectedYear1: null,
      selectedDay2: null,
      selectedDate2: null,
      selectDate2: true,
      selectedMonth2: null,
      selectedYear2: null,
      input1: '',
    };
  },
  mounted() {
    // eslint-disable-next-line no-plusplus
    for (let i = 1700; i <= 2050; i += 1) {
      this.yearList.push({ id: i, year: i });
    }

    if (localStorage.getItem('selectedDate')) {
      const dateRangeObj = JSON.parse(localStorage.getItem('selectedDate'));
      const day1 = moment(dateRangeObj.startDate).format('DD');
      const month1 = moment(dateRangeObj.startDate).local().startOf('month').format('M');
      const year1 = moment(dateRangeObj.startDate).startOf('month').format('YYYY');

      const day2 = moment(dateRangeObj.endDate).format('DD');
      const month2 = moment(dateRangeObj.endDate).endOf('month').format('M');
      const year2 = moment(dateRangeObj.endDate).endOf('month').format('YYYY');

      this.selectedDay1 = day1;
      this.selectedMonth1 = this.monthList[month1 - 1].abbreviation;
      this.selectedYear1 = Number(year1);
      this.selectedDay2 = day2;
      this.selectedMonth2 = this.monthList[month2 - 1].abbreviation;
      this.selectedYear2 = Number(year2);

      this.refresh();
    } else {
      this.getCurrentDate();
    }
  },
  methods: {
    isAfterMethos(dateString1Wfmt, dateString2Wfmt) {
      this.selectedDay1 = dateString2Wfmt.format('DD');
      this.selectedMonth1 = this.monthList[dateString2Wfmt.format('M') - 1].abbreviation;
      this.selectedYear1 = Number(dateString2Wfmt.format('YYYY'));

      this.selectedDay2 = dateString1Wfmt.format('DD');
      this.selectedMonth2 = this.monthList[dateString1Wfmt.format('M') - 1].abbreviation;
      this.selectedYear2 = Number(dateString1Wfmt.format('YYYY'));
      this.refresh();
      return '';
    },
    rangeData(startRange, stopRange) {
      this.$nextTick(() => {
        const textAreaElements = document.getElementsByClassName('dateInput');
        const txt = textAreaElements[0].getElementsByClassName('el-input__inner');
        txt[0].focus();
        txt[0].setSelectionRange(startRange, stopRange);
      });
    },
    onSelectDate() {
      const selectDateList = this.input1.split(this.saperator);
      if (selectDateList.length === 2) {
        const startDateParts = selectDateList[0].split('/');
        const startDate = moment([startDateParts[2], Number(startDateParts[0]) - 1, Number(startDateParts[1])]);
        const endDateParts = selectDateList[1].split('/');
        const endDate = moment([endDateParts[2], Number(endDateParts[0]) - 1, Number(endDateParts[1])]);
        const dateDiffernece = endDate.diff(startDate, 'years', true);
        localStorage.setItem('selectedDate', JSON.stringify({
          endDate: moment(endDate).format('YYYY-MM-DD'),
          startDate: moment(startDate).format('YYYY-MM-DD'),
        }));
        if (dateDiffernece < 1) {
          // allow operation
          this.$emit('apply', selectDateList);
          this.refresh();
          this.visible = false;
        } else {
          // show restricting message
          this.$message({
            showClose: true,
            message: 'Please select a date range of less than one (1) year to be able to view transactions.',
            type: 'error',
          }, 5000);
        }
      } else {
        this.$message({
          message: 'Invalid date selection',
          type: 'error',
        });
      }
    },
    mouseover1() {
      this.$nextTick(() => {
        // Code that will run only after the
        // entire view has been rendered
        const textAreaElements = document.getElementsByClassName('dateInput');
        const txt = textAreaElements[0].getElementsByClassName('el-input__inner');
        txt[0].focus();
        txt[0].setSelectionRange(0, 10);
      });
    },
    mouseover2() {
      this.$nextTick(() => {
        // Code that will run only after the
        // entire view has been rendered
        const textAreaElements = document.getElementsByClassName('dateInput');
        const txt = textAreaElements[0].getElementsByClassName('el-input__inner');

        txt[0].focus();
        txt[0].setSelectionRange(14, 24);
      });
    },
    getActive(value) {
      if (this.selectedQuickLink === value) {
        return 'quick-btn-active';
      }
      return '';
    },
    resetSpecailCase() {
      // Need to verify whether this function is required or not.
    },
    btnDelteClicked() {
      this.getCurrentDate();
    },
    reset() {
      this.getCurrentDate();
      this.onSelectDate();
    },
    today() {
      this.selectedQuickLink = 'today';
      const day1 = moment(new Date()).format('DD');
      const month1 = moment(new Date()).format('M');
      const year1 = moment(new Date()).format('YYYY');


      const day2 = moment(new Date()).format('DD');
      const month2 = moment(new Date()).format('M');
      const year2 = moment(new Date()).format('YYYY');

      this.selectedDay1 = day1;
      this.selectedMonth1 = this.monthList[month1 - 1].abbreviation;
      this.selectedYear1 = Number(year1);
      this.selectedDay2 = day2;
      this.selectedMonth2 = this.monthList[month2 - 1].abbreviation;
      this.selectedYear2 = Number(year2);
      this.refresh();
    },
    yesterday() {
      this.selectedQuickLink = 'Yesterday';
      const day1 = moment(new Date()).subtract(1, 'day').format('DD');
      const month1 = moment(new Date()).subtract(1, 'day').format('M');
      const year1 = moment(new Date()).subtract(1, 'day').format('YYYY');

      const day2 = moment(new Date()).subtract(1, 'day').format('DD');
      const month2 = moment(new Date()).subtract(1, 'day').format('M');
      const year2 = moment(new Date()).subtract(1, 'day').format('YYYY');

      this.selectedDay1 = day1;
      this.selectedMonth1 = this.monthList[month1 - 1].abbreviation;
      this.selectedYear1 = Number(year1);
      this.selectedDay2 = day2;
      this.selectedMonth2 = this.monthList[month2 - 1].abbreviation;
      this.selectedYear2 = Number(year2);
      this.refresh();
    },
    thisMonth() {
      this.selectedQuickLink = 'This month';

      this.getCurrentDate();
    },
    lastMonth() {
      this.selectedQuickLink = 'Last Month';
      const day1 = moment(new Date()).subtract(1, 'months').startOf('month').format('DD');
      const month1 = moment(new Date()).subtract(1, 'months').startOf('month').format('M');
      const year1 = moment(new Date()).subtract(1, 'months').startOf('month').format('YYYY');


      const day2 = moment(new Date()).subtract(1, 'months').endOf('month').format('DD');
      const month2 = moment(new Date()).subtract(1, 'months').endOf('month').format('M');
      const year2 = moment(new Date()).subtract(1, 'months').endOf('month').format('YYYY');

      this.selectedDay1 = day1;
      this.selectedMonth1 = this.monthList[month1 - 1].abbreviation;
      this.selectedYear1 = Number(year1);
      this.selectedDay2 = day2;
      this.selectedMonth2 = this.monthList[month2 - 1].abbreviation;
      this.selectedYear2 = Number(year2);
      this.refresh();
    },
    thisYear() {
      this.selectedQuickLink = 'This Year';
      const day1 = moment(new Date()).startOf('year').format('DD');
      const month1 = moment(new Date()).startOf('year').format('M');
      const year1 = moment(new Date()).startOf('year').format('YYYY');


      const day2 = moment(new Date()).endOf('year').format('DD');
      const month2 = moment(new Date()).endOf('year').format('M');
      const year2 = moment(new Date()).endOf('year').format('YYYY');

      this.selectedDay1 = day1;
      this.selectedMonth1 = this.monthList[month1 - 1].abbreviation;
      this.selectedYear1 = Number(year1);
      this.selectedDay2 = day2;
      this.selectedMonth2 = this.monthList[month2 - 1].abbreviation;
      this.selectedYear2 = Number(year2);
      this.refresh();
    },
    lastYear() {
      this.selectedQuickLink = 'Last Year';
      const day1 = moment(new Date()).subtract(1, 'year').startOf('year').format('DD');
      const month1 = moment(new Date()).subtract(1, 'year').startOf('year').format('M');
      const year1 = moment(new Date()).subtract(1, 'year').startOf('year').format('YYYY');

      const day2 = moment(new Date()).subtract(1, 'year').endOf('year').format('DD');
      const month2 = moment(new Date()).subtract(1, 'year').endOf('year').format('M');
      const year2 = moment(new Date()).subtract(1, 'year').endOf('year').format('YYYY');

      this.selectedDay1 = day1;
      this.selectedMonth1 = this.monthList[month1 - 1].abbreviation;
      this.selectedYear1 = Number(year1);
      this.selectedDay2 = day2;
      this.selectedMonth2 = this.monthList[month2 - 1].abbreviation;
      this.selectedYear2 = Number(year2);
      this.refresh();
    },
    refresh() {
      // eslint-disable-next-line max-len
      const dateString1Wfmt = moment(`${this.selectedMonth1}-${this.selectedDay1}-${this.selectedYear1}`, 'MMM-DD-YYYY');
      // eslint-disable-next-line max-len
      const dateString2Wfmt = moment(`${this.selectedMonth2}-${this.selectedDay2}-${this.selectedYear2}`, 'MMM-DD-YYYY');
      const dateString1 = dateString1Wfmt.format(this.dateFormat);
      const dateString2 = dateString2Wfmt.format(this.dateFormat);
      if (moment(dateString1).isAfter(dateString2)) {
        return this.isAfterMethos(dateString1Wfmt, dateString2Wfmt);
      }
      this.specialCase = {
        m1: this.selectedMonth1,
        m2: this.selectedMonth2,
        y1: this.selectedYear1,
        y2: this.selectedYear2,
      };
      this.selectedDate1 = new Date(dateString1);
      this.selectedDate2 = new Date(dateString2);
      this.input1 = `${dateString1} ${this.saperator} ${dateString2}`;
      return '';
    },
    monthChange1() {
      this.refresh();
      this.rangeData(0, 10);
    },
    yearChange1() {
      this.refresh();
      this.rangeData(0, 10);
    },
    monthChange2() {
      this.rangeData(14, 24);
      this.refresh();
    },
    yearChange2() {
      this.refresh();
      this.rangeData(14, 24);
    },
    handleSelectedDate1(_type, day) {
      this.selectedDay1 = day;
      this.refresh();
      this.rangeData(0, 10);
    },
    handleSelectedDate2(_type, day) {
      this.selectedDay2 = day;
      this.refresh();
      this.rangeData(14, 24);
    },
    getCurrentDate() {
      const day1 = moment(new Date()).startOf('month').format('DD');
      const month1 = moment(new Date()).startOf('month').format('M');
      const year1 = moment(new Date()).startOf('month').format('YYYY');

      const day2 = moment(new Date()).endOf('month').format('DD');
      const month2 = moment(new Date()).endOf('month').format('M');
      const year2 = moment(new Date()).endOf('month').format('YYYY');


      this.selectedDay1 = day1;
      this.selectedMonth1 = this.monthList[month1 - 1].abbreviation;
      this.selectedYear1 = Number(year1);
      this.selectedDay2 = day2;
      this.selectedMonth2 = this.monthList[month2 - 1].abbreviation;
      this.selectedYear2 = Number(year2);


      this.refresh();
    },
    closePopover() {
      this.visible = false;
    },
  },
};
</script>
